import React, { useEffect, useState } from 'react'
import { Box, Button, Checkbox, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs } from '@mui/material'
import { getUserMacRequest } from '../constants'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import TableCellTooltip from '../../../common/TableCellTooltip'
import moment from 'moment'
import { connect } from 'react-redux'
import { getMacRequestAcceptReject, getMacRequestsTableData } from '../../../../store/branchAndUserMaster/BUMAction'
import { isEmpty, navigation1 } from '../../../common/helper'
import { updateAlertError } from '../../../../store/common/common_action'
import SuccessAndErrorModal from '../../../common/SuccessAndErrorModal'
import { useTranslation } from '../../../../i18n/I18nProvider'

const UseMAcRequest = (props) => {
    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const userMacRequest = getUserMacRequest(translations)
    const { data, getMacRequestsTableData, getMacRequestAcceptReject, updateAlertError,loginData } = props
    const { branchAndUserMasterReducer, common } = data
   // const { loginData } = common
    const { MacRequestsTableData } = branchAndUserMasterReducer
    // const { mactabs,getMacRequestsTableData,data} = props
    // const {comman}=data
    const [showTableData, setShowTableData] = useState([])
    const [tableData,setTableData]=useState([])
    const [successmsg, setSuccessmsg] = useState('')
    const [errormsg, setErrormsg] = useState('')
    const [isOpen, setIsOpen] = useState(false)
    const width = window.innerWidth - 40
    // useEffect Start 
    useEffect(() => {
            if (loginData?.intCompanyID!=='undefined') {
                const obj = {
                    CompanyID: loginData?.intCompanyID,
                    IsActive: 0,
                    IsRegistered: 0,
                    BranchID: 0,
                }
                getMacRequestsTableData(obj)
            }
    }, [loginData?.intCompanyID])
    useEffect(()=>{
        if (MacRequestsTableData?.Data?.Table?.length > 0) {
            setShowTableData(MacRequestsTableData?.Data?.Table)
            setTableData(MacRequestsTableData?.Data?.Table)
        } else {
            setShowTableData([])
        }
    },[MacRequestsTableData])

    const [searchData, setSearchData] = useState({
        BranchCode: '',
        BranchName: '',
        CityName: '',
        GUID: '',
        LocationCity: '',
    })
    useEffect(() => {
        let fiterData = tableData?.filter((val) =>
            (searchData.BranchCode === '' || val.BranchCode.toLowerCase().includes(searchData.BranchCode.toLowerCase())) &&
            (searchData.BranchName === '' || val.BranchName.toLowerCase().includes(searchData.BranchName.toLowerCase())) &&
            (searchData.CityName === '' || val.CityName.toLowerCase().includes(searchData.CityName.toLowerCase())) &&
            (searchData.GUID === '' || val.GUID.toLowerCase().includes(searchData.GUID.toLowerCase())) &&
            (searchData.LocationCity === '' || val.LocationCity.toLowerCase().includes(searchData.LocationCity.toLowerCase()))
        )
        setShowTableData(fiterData)
    }, [searchData])
    // useEffect End
    const handleSearchData = (e, field) => {
        setSearchData({ ...searchData, [field]: e.target.value })
    }
    const handleSuccess = (item) => {
        const obj = {
            BranchID: item?.BranchID,
            RequestID: item?.RequestID,
            IsActive: 1
        }
        getMacRequestAcceptReject(obj).then((res) => {
            if (res?.status == 'Success') {
                setIsOpen(true)
            } else {
                updateAlertError({ show: true, msg: res.Message, nextId: 'GSValuation_Type' })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
        setSuccessmsg('Mac Request Accepted')
    }
    const handleReject = (item) => {
        const obj = {
            BranchID: item?.BranchID,
            RequestID: item?.RequestID,
            IsActive: 0
        }
        getMacRequestAcceptReject(obj).then((res) => {
            if (res?.status == 'Success') {
                setIsOpen(true)
            } else {
                updateAlertError({ show: true, msg: res.Message, nextId: 'GSValuation_Type' })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
        setErrormsg('Mac Request Rejected')
    }
    const updateTable = () => {
        const obj = {
            CompanyID: loginData?.intCompanyID,
            IsActive: 0,
            IsRegistered: 0,
            BranchID: 0,
        }
        getMacRequestsTableData(obj)
        setSuccessmsg('')
        setErrormsg('')
    }
    const InsideRowContent = ( item, index ) => {
        const width = window.innerWidth - 40
        return (
            <TableRow key={`DR-${index}`}>
                <TableCell style={{ height: '36px', textAlign: 'right', fontSize: '12px', color: '#666' }}>{index + 1}</TableCell>
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666', maxWidth: '60px' }}>
                    {item?.BranchCode}
                </TableCell>
                <TableCellTooltip
                    maxWidth={`${Math.ceil((width * userMacRequest.widthPercent) / 100)}px`}
                    title={item.BranchName} data={item.BranchName}
                />
                <TableCellTooltip
                    maxWidth={`${Math.ceil((width * userMacRequest.widthPercent) / 100)}px`}
                    title={item.CityName} data={item.CityName}
                />
                <TableCellTooltip
                    maxWidth={`${Math.ceil((width * userMacRequest.widthPercent) / 100)}px`}
                    title={item.GUID} data={item.GUID}
                />
                <TableCellTooltip
                    maxWidth={`${Math.ceil((width * userMacRequest.widthPercent) / 100)}px`}
                    title={item.LocationCity} data={item.LocationCity}
                />
                <TableCell style={{ height: '36px', textAlign: 'left', fontSize: '12px', color: '#666' }}>{moment(item.RequestDate).format('hh:mm DD-MMM-YY')}</TableCell>
                <TableCell style={{ height: '36px', fontSize: '12px', color: '#666', padding: 0 }}>
                    <Button
                        onClick={() => handleSuccess(item)}
                        color="secondary"
                        variant="contained"
                        sx={{ fontSize: '1rem', fontWeight: '500', letterSpacing: '0.24px', lineHeight: 'normal' }}
                    >
                        {bum.accept || 'Accept'}
                    </Button>
                    <Button
                        onClick={() => handleReject(item)}
                        color="secondary"
                        variant="outlined"
                        sx={{ fontSize: '1rem', marginLeft: '12px', fontWeight: '500', letterSpacing: '0.24px', lineHeight: 'normal' }}
                    >
                        {bum.reject || 'Reject'}
                    </Button>
                </TableCell>
            </TableRow>
        )
    }
    return (
        <>
            <Box sx={{ margin: '16px 0px 0px 0px' }}>
                <TableContainer component={Paper} className="scrollBlue" style={{ maxHeight: '70vh', marginBottom: '5px' }}>
                    <Table
                        stickyHeader
                        size="small"
                        aria-label="a dense table"
                        sx={{
                            '& .MuiTableCell-root': {
                                padding: '6px',
                                color: '#444',
                                lineHeight: 1
                            },
                        }}
                    >
                        <TableHead style={{ position: `sticky`, top: `0`, zIndex: '2', whiteSpace: 'pre' }}>
                            <TableRow>
                                {userMacRequest.map((col, index) => (
                                    <TableCell
                                        key={`TH-${index}`}
                                        style={{
                                            ...col.headerSx,
                                            backgroundColor: '#DAEDFE',
                                            height: '36px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            width: col.fixedWidth
                                                ? `${col.fixedWidth}px`
                                                : `${Math.ceil((width * col.widthPercent) / 100)}px`,
                                        }}
                                    >
                                        {col.headerName}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableRow>
                                {userMacRequest.map((col, index) =>
                                    col.showfilter ? (
                                        <TableCell key={`FTH-${index}`} sx={col?.headerSx}>
                                            <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                                <input
                                                    id={`index-${index}`}
                                                    className="field"
                                                    name="cancelSearchInput"
                                                    autoComplete="off"
                                                    value={searchData[col.field]}
                                                    style={{ width: '100%' }}
                                                    placeholder={bum.contains || "Contains"}
                                                    onChange={(e) => handleSearchData(e, col.field)}
                                                    onKeyDown={(e) => navigation1(e, index===5?`index-1`:`index-${index + 1}`,index===1?`index-5`:`index-${index - 1}`)}
                                                />
                                                <FilterAltIcon />
                                            </div>
                                        </TableCell>
                                    ) : (
                                        <TableCell key={`empty-cell-${index}`}></TableCell>
                                    )
                                )}
                            </TableRow>
                        </TableHead>
                        {showTableData?.length <= 0 ? (
                            <>
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={14}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    marginTop: '20px',
                                                    marginBottom: '20px',
                                                    color: 'red',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                <span>{bum.noResultsFoundPleaseRefineYourSearchParametersAndSearchAgain || 'No results found. Please refine your search parameters and search again.'}</span>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </>
                        ) : showTableData.length > 0 ? (
                            <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                                {showTableData?.map((item, index) => InsideRowContent(item, index))}
                            </TableBody>
                        ) : (
                            ''
                        )}
                    </Table>
                </TableContainer>
            </Box>
            {successmsg && (<SuccessAndErrorModal handleClose={() => updateTable()} open={isOpen} title={successmsg} isError={false} />)}
            {errormsg && (<SuccessAndErrorModal handleClose={() => updateTable()} open={isOpen} title={errormsg} isError={true} />)}
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getMacRequestsTableData, getMacRequestAcceptReject, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(UseMAcRequest)
